<template>
  <div
    id="deliveryTemplateSection"
    class="main-area delivery-template-dropdown"
  >
    <PageTop title="Teslimat Şablonu" />
    <div class="input-with-info d-flex flex-column">
      <DropdownSelectable
        :hasError="templateValidation"
        :singleItemTextLength="singleItemTextLength"
        :dropItems="shipmentTemplatesTransform || []"
        :contentBtnClick="navigateCreateNewTemplate"
        @selectedRadioItem="handleDeliveryTemplateSelection"
        label="Teslimat Şablonu Seç"
        notFoundText="Şablon bulunamadı."
        contentBtnText="Yeni Şablon Oluştur"
        isRadioGroup
        :dropdownStateProps="deliveryDropdownState"
        @changedDropdownState="handleChangedVariantsDropdownState"
        searchText="Şablon Ara"
      />
      <div v-if="templateValidation" class="basic-input-icon">
        <TooltipPlugin :tooltipText="'Teslimat Şablonu zorunludur.'">
          <template #tooltip-btn>
            <img src="@/assets/images/icons/alert-circle.svg" />
          </template>
        </TooltipPlugin>
      </div>
    </div>
    <div 
      class="delivery-template-detail" 
      :class="{ 'disabled': !selectedDeliveryTemplate }"
      @click="getTemplateDetail"
    >
      <div class="delivery-template-detail-btn">Şablon Detayını Gör</div>
      <div class="right-arrow"></div>
    </div>
    <Modal
      ref="deliveryDetailModalRef"
      :withCloser="true"
      :showIcon="false"
      :modalStyle="{ width: '896px' }"
      :outsideClickDisabled="false"
      positiveActionText="Kapat"
      negativeActionText="Teslimat Bilgilerine Git"
      @onPositiveActionClick="closeModal"
      @onNegativeActionClick="navigateCreateNewTemplate"
    >
      <template v-slot:body>
        <div v-if="templateDetail">
          <div class="shipment-template-details">
            <h1 class="shipment-template-details-title">Şablon Detayları</h1>
            <div class="shipment-template-details-item">
              <p>Şablon Adı</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.templateName || "Belirtilmemiş"
                }}
              </p>
            </div>
            <div class="shipment-template-details-item">
              <p>Teslimat Metodu</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.shipmentMethod ||
                  "Belirtilmemiş"
                }}
              </p>
            </div>
            <div class="shipment-template-details-item">
              <p>Depo Adresi</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.warehouseAddress ||
                  "Belirtilmemiş"
                }}
              </p>
            </div>
          </div>

          <h1 class="shipment-template-details-subtitle">Kargo Bilgileri</h1>
          <div class="shipment-template-details">
            <div class="shipment-template-details-item">
              <p>Tüm Türkiye'ye gönderim yapıyor musunuz?</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.sendAllCities
                    ? "Evet"
                    : "Hayır" || "Belirtilmemiş"
                }}
              </p>
            </div>
            <div class="shipment-template-details-item">
              <p>Aynı Gün Teslimat yapıyor musunuz?</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.sameDayDeliveryAvailable
                    ? "Evet"
                    : "Hayır" || "Belirtilmemiş"
                }}
              </p>
            </div>
            <div
              class="shipment-template-details-item shipment-template-delivery"
            >
              <p>Kargo Ücreti</p>
              <div class="shipment-template-details-item-fee">
                <p>
                  :
                  {{ templateDetail.deliveryDetail.feeType || "Belirtilmemiş" }}
                </p>
                <p
                  v-if="
                    templateDetail.deliveryDetail.feeType === 'Şartlı Ödeme' &&
                    templateDetail.deliveryDetail.conditionalText
                  "
                >
                  ({{ templateDetail.deliveryDetail.conditionalText }})
                </p>
              </div>
            </div>
            <div class="shipment-template-details-item">
              <p>Birlikte Gönderim</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.combinedShipping ||
                  "Belirtilmemiş"
                }}
              </p>
            </div>
            <div class="shipment-template-details-item">
              <p>Kargo Şirketi Seçimi</p>
              <div class="shipment-template-details-item-delivery">
                <p>
                  :
                  {{
                    templateDetail.deliveryDetail.shipmentCompanies.join(
                      ", "
                    ) || "Belirtilmemiş"
                  }}
                </p>
                <p>{{ templateDetail.conditionalText }}</p>
              </div>
            </div>
          </div>

          <h1 class="shipment-template-details-subtitle">
            İade / Değişim Bilgileri
          </h1>
          <div class="shipment-template-details">
            <div class="shipment-template-details-item">
              <p>İade / Değişim Bilgileri</p>
              <div
                class="shipment-template-details-item-address"
                v-if="templateDetail.deliveryDetail.useSameAddress"
              >
                <p>: Depo adresi ile aynı</p>
                <p>({{ templateDetail.deliveryDetail.warehouseAddress }})</p>
              </div>
            </div>
            <div class="shipment-template-details-item">
              <p>İade / Değişim Kargo Şirket Seçimi</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.claimShipmentCompany ||
                  "Belirtilmemiş"
                }}
              </p>
            </div>
            <div class="shipment-template-details-item">
              <p>Teslimat Bilgileri</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.shippingInfo || "Belirtilmemiş"
                }}
              </p>
            </div>
            <div class="shipment-template-details-item">
              <p>İade / Değişim Ek Bilgiler</p>
              <p>
                :
                {{ templateDetail.deliveryDetail.claimInfo || "Belirtilmemiş" }}
              </p>
            </div>
            <div
              v-if="templateDetail.deliveryDetail.useDmallCargo !== null"
              class="shipment-template-details-item"
            >
              <p>İade/Değişim için n11.com Entegrasyonlu Kargo Firması</p>
              <p>
                :
                {{
                  templateDetail.deliveryDetail.useDmallCargo ? "Evet" : "Hayır"
                }}
              </p>
            </div>
            <div
              v-if="templateDetail.deliveryDetail.installmentInfo !== null"
              class="shipment-template-details-item"
            >
              <p>Satış Sonrası Servis</p>
              <p v-html="sanitizedInstallmentInfo"></p>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script setup>
import { ref, computed, defineExpose, onMounted } from "vue";
import { useStore } from "vuex";
import PageTop from "@/components/Page/PageTop.vue";
import { DropdownSelectable, TooltipPlugin } from "@n11/so-ui-components";
import { DELIVERY_DETAIL } from "@/utils/enum/endpoints";
import Request from "@/services/request";
import { Modal } from "@n11/so-ui-components";

const store = useStore();

const shipmentTemplates = ref();
const singleItemTextLength = ref(80);
const selectedTemplatesIds = ref([]);
const selectedDeliveryTemplate = ref(null);
const deliveryDetailModalRef = ref();
const templateDetail = ref(null);
const deliveryDropdownState = ref(false);
const templateValidation = ref(false);

const getTemplateDetail = async () => {
  if (!selectedDeliveryTemplate.value) {
    return;
  }
  
  const selectedId = selectedTemplatesIds.value;
  const request = new Request();

  try {
    const response = await request.get(
      `${DELIVERY_DETAIL}/${selectedId}`,
      null,
      {
        baseURL: "/selleroffice/rest",
        headers: { Accept: "application/json" },
      }
    );
    templateDetail.value = response.data;
    openModal();
  } catch (error) {
    console.error("Error:", error);
  }
};

const getShipmentTemplates = async () => {
  try {
    const response = await store.dispatch("templates/getShipmentTemplates");
    shipmentTemplates.value = response.data.shipmentTemplates;
  } catch (error) {
    console.error("Error:", error);
  }
};

const shipmentTemplatesTransform = computed(() => {
  return shipmentTemplates.value?.map((item) => ({
    id: item.id,
    name: item.templateName,
  }));
});

const sanitizedInstallmentInfo = computed(() => {
  if (templateDetail.value?.deliveryDetail?.installmentInfo) {
    return JSON.parse(
      JSON.stringify(templateDetail.value?.deliveryDetail?.installmentInfo)
    );
  }
  return "";
});

const navigateCreateNewTemplate = () => {
  window.open("/selleroffice/product/shippingInformationList", "_blank");
};

const handleDeliveryTemplateSelection = (selection) => {
  selectedTemplatesIds.value = [selection.id];
  selectedDeliveryTemplate.value = selection;
  deliveryDropdownState.value = false;

  if (selection) {
    templateValidation.value = false;
  }
};

const handleChangedVariantsDropdownState = (state) => {
  deliveryDropdownState.value = state;
};

const openModal = () => {
  deliveryDetailModalRef.value?.openModal();
};

const closeModal = () => {
  deliveryDetailModalRef.value?.hiddenModal();
};

const getDeliveryTemplate = () => {
  const selectedTemplate = selectedDeliveryTemplate.value;
  const isValid = !!selectedTemplate;

  templateValidation.value = !isValid;

  return {
    data: { selectedTemplate },
    isValid,
  };
};

defineExpose({
  openModal,
  closeModal,
  getDeliveryTemplate,
});

onMounted(() => {
  getShipmentTemplates();
});
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/utilities.scss";

.main-area {
  width: 100%;
  display: flex;
  gap: 16px;
  padding: 24px;
  border: 1px solid $colorD20;
  border-radius: 8px;
}

.delivery-template-dropdown {
  :deep(.dropdownSelectable-content-list) {
    max-height: 160px;
  }
}

.delivery-template-detail {
  display: flex;
  flex-direction: row;
  align-items: center;

  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
    
    .delivery-template-detail-btn {
      color: $colorD30;
    }
    
    .right-arrow {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='13' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill-rule='evenodd' d='M1.706.293a1 1 0 0 0-1.497 1.32l.083.094 4.582 4.581-4.582 4.57a1 1 0 0 0-.083 1.32l.083.094a1 1 0 0 0 1.32.083l.094-.083 5.29-5.277a1 1 0 0 0 .083-1.32l-.083-.094L1.706.293z' fill='%23D3D6DF'/%3E%3C/svg%3E");
    }
  }

  &-btn {
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.05px;
    color: $colorM50;
    cursor: pointer;
  }
}

.right-arrow {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='13' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill-rule='evenodd' d='M1.706.293a1 1 0 0 0-1.497 1.32l.083.094 4.582 4.581-4.582 4.57a1 1 0 0 0-.083 1.32l.083.094a1 1 0 0 0 1.32.083l.094-.083 5.29-5.277a1 1 0 0 0 .083-1.32l-.083-.094L1.706.293z' fill='%23f4e'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 12px;
  height: 12px;
  vertical-align: sub;
}

.shipment-template-details {
  &:not(:last-child) {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 0.5px solid #d3d6df;
  }

  &-title {
    text-align: left;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: -0.2px;
    margin-bottom: 24px;
  }

  .shipment-template-delivery {
    justify-content: start;

    p {
      font-weight: 400;
      width: 300px;
    }
  }

  &-item {
    display: flex;
    flex-direction: row;
    gap: 8px;
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
    justify-content: space-between;

    &-fee,
    &-address,
    &-delivery {
      display: flex;
      flex-direction: column;
      align-items: start;

      p:nth-child(2) {
        font-weight: 400 !important;
        padding-left: 5px;
      }
    }

    &:not(:last-child) {
      margin-bottom: 12px;
    }

    p:nth-child(1) {
      font-size: 13px;
      font-weight: 700;
      letter-spacing: -0.05px;
      line-height: 18px;
      max-width: 295px;
      text-align: start;
    }

    p:nth-child(2) {
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
      text-align: justify;
      width: 542px;
    }
  }

  &-subtitle {
    text-align: left;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.05px;
    margin-bottom: 20px;
  }
}

.input-with-info {
  gap: 4px;
  position: relative;
  width: 50% !important;

  span {
    font-size: 11px;
    line-height: 14px;
    color: $colorN60;
    padding: 0 12px;
  }

  .basic-input-icon {
    position: absolute;
    z-index: 1;
    right: 0px;
    top: 11px;
    cursor: pointer;

    img {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
